import {
	StyleSettingsImageUploaderContext,
	IStyleSettingsImageUploaderContext,
} from '../../styleSettingsImageUploaderState/styleSettingsImageUploaderContext';
import React, { useContext } from 'react';
import { IMaxFileSizeMBStyleSettings } from 'types';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ErrorModals.module.scss';

interface IErrorModals {
	maxFileSizeMB?: IMaxFileSizeMBStyleSettings;
}

const ErrorModals: React.FC<IErrorModals> = ({ maxFileSizeMB }) => {
	const { changeTypeOfErrorModalWindow, typeOfErrorModalWindow } = useContext<IStyleSettingsImageUploaderContext>(
		StyleSettingsImageUploaderContext,
	);

	const containerClasses = classNames(style.container, { [style.visible]: typeOfErrorModalWindow });

	const handleCloseModal = () => {
		changeTypeOfErrorModalWindow(null);
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'imgFileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={{ size: `${maxFileSizeMB?.img}MB` }}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'gifFileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={{ size: `${maxFileSizeMB?.gif}MB` }}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'fileUploadError'}
				description="fileUploadError"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'invalidImageFormat'}
				description="invalidFileFormatPhoto"
				translationOptions={{ formats: '.jpeg, .jpg, .png' }}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'invalidGifFormat'}
				description="invalidFileFormatGif"
				translationOptions={{ formats: '.gif' }}
			/>
		</div>
	);
};

export default ErrorModals;
